<template>
  <header :class="['main-header', $store.getters.env]">
    <a href="/home" class="logo">
      <span class="logo-mini">
          <img class="img-responsive center-block" src="/static/img/logo-mini.svg">
        </span>
      <span class="logo-lg">
          <img :class="checkEnv() ? 'img-responsive center-block': 'img-responsive center-block logo-st'" :src="`${checkEnv() ? '/static/img/logo-lg.svg': '/static/img/staging.svg'}`">
        </span>
    </a>
    <nav class="navbar navbar-static-top" role="navigation">
      <a href="javascript:;" class="sidebar-toggle" data-toggle="offcanvas" role="button">
        <span class="sr-only">Toggle navigation</span>
      </a>
      <div class="navbar-custom-menu">
        <ul class="nav navbar-nav">
          <li style="margin-top: 3%; fontSize: 15px;">
            <span>Händler-Support: Tel. 06182 - 928 2282</span>
          </li>
          <li class="dropdown messages-menu">
            <a href="javascript:;" class="dropdown-toggle" data-toggle="dropdown">
              <i class="fa fa-envelope-o"></i>
              <span class="label label-success"></span>
            </a>
            <ul class="dropdown-menu">
              <li class="header"></li>
              <li v-if="state.userInfo && state.userInfo.messages.length > 0">
                <ul class="menu">
                  <li>
                    <a href="javascript:;">
                      <h4>
                        Support Team
                        <small><i class="fa fa-clock-o"></i> 5 mins</small>
                      </h4>
                      <p>Why not consider this a test message?</p>
                    </a>
                  </li>
                </ul>
              </li>
              <li class="footer" v-if="state.userInfo && state.userInfo.messages.length > 0"><a href="javascript:;">See All Messages</a></li>
            </ul>
          </li>
          <li class="dropdown notifications-menu">
            <a href="javascript:;" class="dropdown-toggle" data-toggle="dropdown">
              <i class="fa fa-bell-o"></i>
              <span v-if="labelErrors.total > 0" class="label label-warning">{{labelErrors.total}}</span>
            </a>
            <ul class="dropdown-menu">
              <li class="header" v-if="labelErrors.total >0">{{labelErrors.total}} Versanddokument(e) erstellt</li>
              <li v-if="labelErrors.data && labelErrors.data.length >0">
                <ul class="menu">
                  <li v-for="error in labelErrors.data">
                    <a href="#" @click="updateLabelError(error.id, error.order_id)" :class="[error.read ? 'text-muted' : 'text-bold']"><i :class="['fa', error.read ?  'fa-check-circle  text-success' : 'fa-circle text-warning', 'mr-5']"></i>#{{error.order_id}} - Versanddokumente erstellt
                    </a>
                  </li>
                </ul>
              </li>
              <li v-else>
                <a href="#"><span class="text-info">Keine Fehler vorhanden</span></a>
              </li>
              <li class="footer" v-if="state.userInfo && state.userInfo.notifications.length > 0"><a href="javascript:;">View all</a></li>
            </ul>
          </li>
          <li class="dropdown tasks-menu">
            <a href="javascript:;" class="dropdown-toggle" data-toggle="dropdown">
              <i class="fa fa-flag-o"></i>
              <span class="label label-danger"></span>
            </a>
            <ul class="dropdown-menu">
              <li class="header"></li>
              <li v-if="state.userInfo && state.userInfo.tasks.length > 0">
                <ul class="menu">
                  <li><!-- Task item -->
                    <a href="javascript:;">
                    </a>
                  </li>
                </ul>
              </li>
              <li class="footer" v-if="state.userInfo && state.userInfo.tasks.length > 0">
                <a href="javascript:;">View all tasks</a>
              </li>
            </ul>
          </li>
          <li>
          </li>
          <li class="dropdown user user-menu">
            <a href="#" class="dropdown-toggle" data-toggle="dropdown">
              <img :src="`/static/img/${user.image}`" class="user-image" alt="User Image">
              <span class="hidden-xs">{{ user.company }}</span>
            </a>
            <ul class="dropdown-menu">
              <!-- User image -->
              <li class="user-header">
                <img :src="`/static/img/${user.image}`" class="img-circle" alt="User Image">
                <p>
                  {{user.first_name}} {{user.last_name }}
                  <small>{{user.username}}</small>
                </p>
              </li>
              <!-- Menu Body -->
              <li class="user-body">
                <div class="row">
                  <div class="col-xs-12 text-center">
                    <div class="btn-group">
                      <button type="button" class="btn disabled">{{'language' | translate }}</button>
                      <button type="button" :class ="[{active: language === 'de'}, 'btn']" @click.prevent="changeLanguage('de')"><img class="center-block" src="/static/img/de.png" alt="German" title="Change Language"></button>
                      <button type="button" :class ="[{active: language === 'en'}, 'btn']" @click.prevent="changeLanguage('en')"><img class="center-block" src="/static/img/en.png" alt="English" title="Change Language"></button>
                      <!--<button type="button" :class ="[{active: language === 'es'}, 'btn']" @click.prevent="changeLanguage('es')"><img class="center-block" src="/static/img/es.png" alt="Spanish" title="Change Language"></button>-->
                    </div>
                  </div>
                </div>
                <!-- /.row -->
              </li>
              <!-- Menu Footer-->
              <li class="user-footer">
                <div class="pull-left">
                  <router-link to="/accounting/users" class="btn btn-default"><i class="fa fa-user-circle"></i> {{'account' | translate}}</router-link>
                </div>
                <div class="pull-right">
                  <a @click="$store.dispatch('logout')" class="btn btn-danger" >{{'logout' | translate}} <i class="fa fa-power-off"></i></a>
                </div>
              </li>
            </ul>
          </li>
        </ul>
      </div>
    </nav>
  </header>
</template>

<script>
  export default {
    name: 'HeaderBar',
    props: [],
    data () {
      return {
        language: 'de',
        labelErrors: {total: 0},
        state: this.$store.state,
        user: this.$store.getters.user
      }
    },
    methods: {
      getLabelErrors () {
        API.get('/messages/labelerrors')
          .then(res => {
            this.labelErrors = res.data
          })
          .catch(error =>{
          })
      },
      updateLabelError (id, orderId) {
        API.put(`/messages/labelerrors/${id}/hidden`, [])
          .then(res => {
            API.get('/messages/labelerrors')
              .then(res => {
                this.labelErrors = res.data
                this.$router.push(`/orders/${orderId}`)
              })
              .catch(error =>{
              })
          })
          .catch(error => {
            console.log(error)
          })
      },
      checkEnv () {
        return ['qb-schuhe.de', 'qualibet-schuhe.de', 'qbschuhe.de', 'www.qb-schuhe.de', 'www.qualibet-schuhe.de', 'www.qbschuhe.de', 'myplace.schuhe.de'].indexOf(window.location.hostname) !== -1
      },
      changeLanguage (lang) {
        this.$store.commit('updateLanguage', lang)
        this.language = lang
      },
    },
    mounted () {
      this.getLabelErrors()
      setInterval(this.getLabelErrors, 300000)
    }
  }
</script>

<style scoped>
  .staging {
    background-color: #5b4094 !important;
  }
  .dev {
    background-color: #136178 !important;
  }
  .logo-st{
    width: 70%;
    -webkit-animation:spin 4s linear infinite;
    -moz-animation:spin 4s linear infinite;
    animation:spin 4s linear infinite;
    height: 50px !important;
  }
  @-moz-keyframes spin { 100% { -moz-transform: rotateY(360deg); } }
  @-webkit-keyframes spin { 100% { -webkit-transform: rotateY(360deg); } }
  @keyframes spin { 100% { -webkit-transform: rotateY(360deg); transform:rotateY(360deg); } }
</style>




// WEBPACK FOOTER //
// src/components/tools/HeaderBar.vue